export default "__VITE_ASSET__DzdafCVT__"